import { NgModule } from "@angular/core";
import {CommonModule, NgOptimizedImage} from '@angular/common';
import { EvrideoCommonModule } from "../common/evrideo-common.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { RouterModule } from "@angular/router";
import { InlineSVGModule } from "ng-inline-svg-2";
import { FormsModule } from "@angular/forms";
import { AgGridModule } from "ag-grid-angular";
import { AngularDraggableModule } from "angular2-draggable";
import {UserBrandingRoutes} from './user-branding.routes';
import {
  UserBrandingEditComponent
} from './user-branding-edit/user-branding-edit.component';
import {UserBrandingComponent} from './user-branding.component';
import {
  UserBrandingDashboardComponent
} from './user-branding-dashboard/user-branding-dashboard.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    EvrideoCommonModule,
    BrowserAnimationsModule,
    InlineSVGModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: 'toast-top-center',
      tapToDismiss: false,
      timeOut: 5000,
    }),
    RouterModule.forRoot(UserBrandingRoutes),
    AgGridModule,
    AngularDraggableModule,
    NgOptimizedImage,
  ],
  declarations: [
    UserBrandingEditComponent,
    UserBrandingComponent,
    UserBrandingDashboardComponent
  ],
  providers: [],
  exports: [RouterModule],
})
export class UserBrandingModule {}
